export const MODAL_SELECTOR = '.modal.modal--js';
export const IS_HIDDEN_CLASSNAME = 'is-hidden';
export const IS_MODAL_SHOW_CLASSNAME = 'is-modal-show';
export const MODAL_CONTENT_SELECTOR = '.modal__content';
export const MODAL_LOADER_SELECTOR = '.modal__loader';
